/**
 * roundOff `value` to decimal `places`
 * @param value numeric value to roundOff
 * @param places decimal places to roundOff `value` to
 * @returns a string notation of rounded off number
 */
export const roundOff = (value: number, places: number = 2) =>
    // toFixed internally rounds off the number
    value.toFixed(places);

// Regular expression for matching numbers only
export const NUMBER_REGEX = RegExp(/^[0-9]*$/);

/**
 * Given a number and locale, this function returns the number in the locale's format
 * formatNumberWithCommas({ num: 1234567.89, locale: 'en-IN'}) "12,34,567.89" (Indian English format)
 * formatNumberWithCommas({ num: 1234567.89, locale: 'en-US'}) "1,234,567.89" (US English format)
 * @param param0 num { number } - The number we want comma separated value
 * @param param1 locale { string } - The locale of the area we want it in
 * @returns string - The converted number in commas format
 */
export const formatNumberWithCommas = ({
    num,
    locale = "en-US",
}: {
    num: number | string;
    locale?: string;
}): string => {
    const numToChange = +num;

    return numToChange.toLocaleString(locale);
};
